<template>
  <div class="page-container">
    <main class="main-content">
      <section v-if="carouselAds && carouselAds.length > 0" class="hero">
        <el-carousel height="360px" indicator-position="outside" :interval="5000" arrow="hover">
          <el-carousel-item v-for="(b,i) in carouselAds" :key="i">
            <div class="carousel-slide" :style="bannerStyle(b)">
              <div class="overlay">

              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </section>

      <!-- Banner Section -->
      <section v-if="bannerAds && bannerAds.length > 0" class="banner-section">
        <div class="page-inner-box">
          <div class="banner-list">
            <div v-for="(item, i) in bannerAds" :key="i" class="banner-item" @click="openAd(item)">
              <img :src="item.adImage" :alt="item.adTitle">
            </div>
          </div>
        </div>
      </section>

      <section class="plan">
        <div class="page-inner-box">
          <div class="sec-head">
            <div class="title">
              <img src="@/assets/new_picture/i_tt.png" alt="" class="tag"> 
              <span>考试计划</span>
            </div>
            <div class="subtitle">只为精心雕琢 为塑造代表不凡的你 而有最好 只有更好</div>
          </div>
          <div class="plan-wrap">
            <div class="plan-image">
              <el-carousel height="100%" :interval="3000" indicator-position="none" arrow="never" ref="planCarousel">
                <el-carousel-item v-for="(img, idx) in planImages" :key="idx">
                  <img :src="img" class="plan-carousel-img" alt="考试计划">
                </el-carousel-item>
              </el-carousel>
              <div class="custom-indicators">
                <span 
                  v-for="(img, idx) in planImages" 
                  :key="idx" 
                  class="indicator-dot" 
                  :class="{ active: currentPlanIndex === idx }"
                  @click="setActivePlanItem(idx)"
                ></span>
              </div>
            </div>
            <div class="plan-list-container">
              <div class="plan-list">
                <el-empty v-if="!plans || plans.length === 0" description="暂无考试安排" />
                <div v-else class="plan-item" v-for="(p,i) in plans" :key="p.id" @click="goPlan(p)">
                  <div class="plan-date-box" :class="{ 'highlight': i < 2 }">
                    <span class="d-month">{{ p.month || '01' }}</span>
                    <span class="d-sep">.</span>
                    <span class="d-day">{{ p.day || '01' }}</span>
                  </div>
                  <div class="plan-info">
                    <div class="plan-title" :class="{ 'highlight': i < 2 }">{{ p.title }}</div>
                  </div>
                  <div class="plan-arrow"><i class="el-icon-arrow-right"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="query">
        <div class="page-inner-box">
          <div class="sec-head">
            <div class="title">
              <img src="@/assets/new_picture/i_tt.png" alt="" class="tag"> 
              <span>成绩查询</span>
            </div>
            <div class="subtitle">只为精心推荐 为您的英才计划保驾护航 没有最好 只有更好</div>
          </div>
          <div class="query-container">
            <div class="left-panel">
              <div class="form-card-blue">
                <div class="card-header">职业技能等级证书</div>
                <el-form :model="form" class="form-blue">
                  <div class="form-item">
                    <span class="label">学员姓名：</span>
                    <el-input v-model="form.name" placeholder="请输入真实姓名" />
                  </div>
                  <div class="form-item">
                    <span class="label">准考证号：</span>
                    <el-input v-model="form.ticketNo" placeholder="请输入准考证号（与证件号码二选一）" maxlength="18" />
                  </div>
                  <div class="form-item">
                    <span class="label">证件号码：</span>
                    <el-input v-model="form.idNo" placeholder="请输入身份证号（与准考证号二选一）" maxlength="18" />
                  </div>
                  <el-button type="primary" class="query-btn-blue" @click="submitQuery">查询</el-button>
                </el-form>
              </div>
              <div class="query-desc">
                查询说明：<br>
                请输入学员姓名和准考证号，或学员姓名和证件号码进行查询。<br>
                准考证号与证件号码填写其中一项即可。<br>
                如果成绩还没有公布，请晚些时候再来查询。
              </div>
            </div>
            
            <div class="right-panel">
              <div class="notice-header">
                <span class="nt-title">违规通知</span>
                <div class="dots">
                  <span v-for="i in 3" :key="i" class="dot"></span>
                </div>
              </div>
              
              <div class="violation-list" ref="violationListRef" @mouseenter="isUserScrolling = true" @mouseleave="isUserScrolling = false">
                 <template v-if="violationList && violationList.length > 0">
                   <div class="v-item" v-for="(item, i) in violationList" :key="i">
                     <span class="tag-violation">违规</span>
                     <span class="v-text">{{ item.studentName }}<template v-if="item.idCardMasked">，证件号码：{{ item.idCardMasked }}</template>，{{ item.examName }}考试违纪，成绩作废</span>
                   </div>
                 </template>
                 <div v-else class="no-violation">
                   <el-empty description="暂无违规通知" :image-size="80" />
                 </div>
               </div>
              
            </div>
          </div>
        </div>
      </section>

      <section v-if="courseKeyword" class="course-search">
        <div class="page-inner-box">
          <div class="sec-head">
            <div class="title">
              <img src="@/assets/new_picture/i_tt.png" alt="" class="tag"> 
              <span>课程搜索</span>
            </div>
            <div class="subtitle">只为精心雕琢 为塑造代表不凡的你 而有最好 只有更好</div>
          </div>
          <div v-loading="courseLoading" class="course-body">
            <div v-if="courseList.length > 0" class="course-grid">
              <div v-for="c in courseList" :key="c.id" class="course-card" @click="goCourse(c)">
                <div class="course-thumb"><img :src="c.coverImage" alt="cover" /></div>
                <div class="course-info">
                  <div class="course-tt" :title="c.courseName">{{ c.courseName }}</div>
                  <div class="course-sub" :title="c.subtitle">{{ c.subtitle }}</div>
                  <div class="course-meta">
                    <span class="course-views">{{ c.viewCount }}人已学</span>
                    <span class="course-price">{{ c.priceText }}</span>
                  </div>
                </div>
              </div>
            </div>

            <el-empty v-else-if="!courseLoading" description="暂无课程" />
          </div>

          <div v-if="courseTotal > coursePageSize" class="course-pager">
            <el-pagination
              :current-page="coursePageNum"
              :page-size="coursePageSize"
              layout="prev, pager, next"
              :total="courseTotal"
              @current-change="handleCoursePageChange"
            />
          </div>
        </div>
      </section>

      <section class="hot">
        <div class="page-inner-box">
          <div class="sec-head">
            <div class="title">
              <img src="@/assets/new_picture/i_tt_2.png" alt="" class="tag"> 
              <span style="color:#fff">近期热门考试</span>
            </div>
            <div class="subtitle">只为精心雕琢 为塑造代表不凡的你 而有最好 只有更好</div>
          </div>
          <div class="hot-rotator">
            <div v-if="hotSlides.length > 0" class="hot-featured">
              <div class="hot-coverflow">
                <div
                  v-for="(h, index) in hotSlides"
                  :key="h.id"
                  class="coverflow-item"
                  :class="{
                    'active': index === currentHotIndex,
                    'prev': index === (currentHotIndex - 1 + hotSlides.length) % hotSlides.length,
                    'next': index === (currentHotIndex + 1) % hotSlides.length
                  }"
                  @click="currentHotIndex = index"
                >
                  <img :src="h.coverImage || require('@/assets/image/study_placeholder.png')" alt="hot exam cover" />
                </div>
              </div>

              <div class="hot-info" v-if="activeHotExam">
                <div class="hot-title">{{ activeHotExam.title }}</div>
                <div class="hot-time">考试时间：{{ activeHotExam.start }} - {{ activeHotExam.end }}</div>
                <div class="hot-meta">考试时长：{{ activeHotExam.duration }}分钟 &nbsp;&nbsp; 及格分数：{{ activeHotExam.pass }}分</div>
                <el-button type="primary" class="hot-card-btn" @click="goHotExam(activeHotExam)">立即考试</el-button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="halls">
        <div class="page-inner-box">
          <div class="sec-head">
            <div class="title">
              <img src="@/assets/new_picture/i_tt.png" alt="" class="tag"> 
              <span>考试列表</span>
            </div>
            <div class="subtitle">只为精心推荐 为您的英才计划保驾护航 没有最好 只有更好</div>
          </div>
          
          <div class="hall-tabs-centered">
            <div class="ht-item" :class="{active: hallStatusTab==='进行中'}" @click="hallStatusTab='进行中'">进行中</div>
            <div class="ht-item" :class="{active: hallStatusTab==='未开始'}" @click="hallStatusTab='未开始'">未开始</div>
            <div class="ht-item" :class="{active: hallStatusTab==='历史考试'}" @click="hallStatusTab='历史考试'">历史考试</div>
          </div>

          <div class="hlist" :class="displayedHalls.length === 1 ? 'grid-mode-single' : 'grid-mode-multi'">
            <div class="exam-card" v-for="h in displayedHalls" :key="h.id">
              <div class="ec-head">
                <span class="ec-tag">{{ h.category }}</span>
                <span class="ec-title">{{ h.title }}</span>
              </div>
              <div class="ec-body">
                <div class="ec-row">考试时间：{{ h.start }} - {{ h.end }}</div>
                <div class="ec-row">考试时长：{{ h.duration }}分钟 <span class="sep"></span> 总分：{{ h.total }}分 <span class="sep"></span> 及格分数：{{ h.pass }}分</div>
              </div>
              <div class="ec-foot">
                <el-button v-if="h.status==='ongoing'" class="enter-btn" round size="small" @click="doExam(h)">进入考试 ></el-button>
                <el-button v-else-if="h.status==='upcoming'" type="info" plain round size="small" disabled>未开始</el-button>
                <el-button v-else type="info" plain round size="small" disabled>已结束</el-button>
              </div>
            </div>
            <el-empty v-if="displayedHalls.length === 0" description="暂无考试" style="grid-column: span 2;" />
          </div>
          
          <div v-if="filteredHalls.length > 6" class="view-more-btn" @click="goToExamList">
            查看更多
          </div>
        </div>
      </section>

      <el-dialog title="查询结果" :visible.sync="queryDialogVisible" width="400px" center>
        <div v-if="queryResult" class="result-box">
          <div class="result-row">
            <span class="label">姓名：</span>
            <span class="value">{{ queryResult.studentName }}</span>
          </div>
          <div class="result-row">
            <span class="label">证件号码：</span>
            <span class="value">{{ queryResult.idCard }}</span>
          </div>
          <div class="result-row">
            <span class="label">考试名称：</span>
            <span class="value">{{ queryResult.examName }}</span>
          </div>
          <div class="result-row">
            <span class="label">考试成绩：</span>
            <span class="value score">{{ queryResult.totalScore }}分</span>
          </div>
          <div class="result-row" v-if="queryResult.isForceSubmit === 1">
            <el-tag type="warning" size="small">强制交卷</el-tag>
          </div>
          <div class="result-row" v-if="queryResult.certificateNo">
            <span class="label">证书编号：</span>
            <span class="value">{{ queryResult.certificateNo }}</span>
          </div>
          <div class="result-row" v-if="queryResult.certificateName">
            <span class="label">证书名称：</span>
            <span class="value">{{ queryResult.certificateName }}</span>
          </div>
          <div class="result-row" v-if="queryResult.certificateFileUrl">
            <span class="label">证书查看：</span>
            <el-button type="primary" size="small" @click="viewCertificate(queryResult.certificateFileUrl)">查看证书</el-button>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="queryDialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

    <AdPopup v-if="popupAd" :ad="popupAd" page-id="exam" />
    <AdFloat v-if="floatAd" :ad="floatAd" />

    </main>
  </div>
</template>

<script>
import Swiper from 'swiper';
import AdPopup from '@/components/AdPopup.vue'
import AdFloat from '@/components/AdFloat.vue'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';
import { getAdvertisementList, getFrontendExamList, getGradeQuery, getMyExamList } from '@/api/examApi'
import { getCourseList, getHomepageRecommendContents } from '@/api/courseApi'
import { getViolationList } from '@/api/certificationApi'

const defaultPlanThumb = require('@/assets/image/study_placeholder.png')

export default {
  name: 'AppExam',
  components: { AdPopup, AdFloat },
  data() {
    return {
      plans: [],
      currentPlanIndex: 0,
      queryDialogVisible: false,
      queryResult: null,
      form: { ticketNo: '', idNo: '', name: '' },
      historyList: [
       
      ],
      carouselAds: [], // Renamed from banners
      popupAd: null,
      bannerAds: [],
      floatAd: null,
      hotSlides: [],
      currentHotIndex: 0,
      hotCoverflowTimer: null,
      hallStatusTab: '进行中',
      halls: [],
      hallLoading: false,
      hallTotal: 0,
      hallPageNum: 1,
      hallPageSize: 10,
      hotSwiper: null,
      modules: [EffectCoverflow, Pagination, Autoplay],
      courseKeyword: '',
      courseLoading: false,
      courseTotal: 0,
      coursePageNum: 1,
      coursePageSize: 8,
      courseList: [],
      // Mock data for notices
      planImages: [],
      notices: [],
      violationList: [],
      violationScrollTimer: null,
      isUserScrolling: false
    }
  },
  computed: {
    activeHotExam() {
      if (!this.hotSlides || this.hotSlides.length === 0) return null
      return this.hotSlides[this.currentHotIndex] || this.hotSlides[0]
    },
    noticeGroups() {
      const groups = []
      const list = this.violationList || []
      for (let i = 0; i < list.length; i += 6) {
        groups.push(list.slice(i, i + 6))
      }
      return groups
    },
    filteredHalls() {
      return this.halls
    },
    displayedHalls() {
      return this.filteredHalls.slice(0, 6)
    }
  },
  watch: {
    hallStatusTab() {
      this.hallPageNum = 1
      this.fetchExamList()
    },
    '$route.query.keyword'(next) {
      const keyword = String(next || '').trim()
      if (keyword === String(this.courseKeyword || '').trim()) return
      this.courseKeyword = keyword
      this.coursePageNum = 1
      if (!this.courseKeyword) {
        this.courseList = []
        this.courseTotal = 0
        return
      }
      this.fetchCourseList()
    }
  },
  mounted() {
    this.fetchBanners()
    this.fetchBannerAds()
    this.fetchPlanImages()
    this.fetchExamPlans()
    this.fetchHotExams()
    this.fetchExamList()
    this.fetchViolationList().then(() => {
      this.$nextTick(() => {
        this.startViolationScroll()
      })
    })
    this.courseKeyword = String((this.$route && this.$route.query && this.$route.query.keyword) || '').trim()
    if (this.courseKeyword) this.fetchCourseList()
    this.startHotCoverflowAutoScroll()
  },
  beforeDestroy() {
    if (this.hotSwiper && this.hotSwiper.destroy) {
      this.hotSwiper.destroy(true, true)
    }
    if (this.violationScrollTimer) {
      cancelAnimationFrame(this.violationScrollTimer)
      this.violationScrollTimer = null
    }
    if (this.hotCoverflowTimer) {
      clearInterval(this.hotCoverflowTimer)
      this.hotCoverflowTimer = null
    }
  },
  methods: {
    async fetchViolationList() {
      try {
        const res = await getViolationList()
        if (res.code === 200 && Array.isArray(res.data)) {
          this.violationList = res.data
        } else {
          this.violationList = []
        }
      } catch (err) {
        console.error('获取违规通知列表失败', err)
        this.violationList = []
      }
    },
    startViolationScroll() {
      if (!this.$refs.violationListRef) return
      const el = this.$refs.violationListRef
      let lastTime = 0
      const speed = 0.5 // pixels per frame (slower = smoother)
      
      const animate = (currentTime) => {
        if (!lastTime) lastTime = currentTime
        const delta = currentTime - lastTime
        
        if (delta >= 16) { // ~60fps
          if (!this.isUserScrolling && this.violationList && this.violationList.length > 0) {
            const maxScroll = el.scrollHeight - el.clientHeight
            if (maxScroll > 0) {
              if (el.scrollTop >= maxScroll) {
                el.scrollTop = 0
              } else {
                el.scrollTop += speed
              }
            }
          }
          lastTime = currentTime
        }
        
        this.violationScrollTimer = requestAnimationFrame(animate)
      }
      
      this.violationScrollTimer = requestAnimationFrame(animate)
    },
    setActivePlanItem(idx) {
      this.$refs.planCarousel.setActiveItem(idx)
      this.currentPlanIndex = idx
    },
    maskIdNo(val) {
      const s = String(val || '').trim()
      if (!s) return ''
      if (s.length <= 8) return `${s.slice(0, 1)}****${s.slice(-1)}`
      return `${s.slice(0, 3)}********${s.slice(-4)}`
    },
    appendHistory(result) {
      const r = result || {}
      const name = String(r.studentName || this.form.name || '').trim()
      const idNo = String(r.idCard || this.form.idNo || '').trim()
      const certNo = String(this.form.certNo || '').trim()
      const score = Number(r.totalScore || 0)
      const invalid = Boolean(r.invalid || r.isInvalid || r.scoreInvalid)
      const entry = {
        name,
        idMasked: this.maskIdNo(idNo),
        score,
        invalid,
        certNo,
        idNo
      }
      const idx = this.historyList.findIndex(h => String(h.certNo || '') === certNo && String(h.idNo || '') === idNo)
      if (idx >= 0) this.historyList.splice(idx, 1)
      this.historyList.unshift(entry)
      if (this.historyList.length > 10) this.historyList = this.historyList.slice(0, 10)
    },
    viewCertificate(url) {
      if (!url) return
      window.open(url, '_blank')
    },
    async fetchExamPlans() {
      try {
        const res = await getHomepageRecommendContents({ contentCategory: 'exam_plan' })
        const list = Array.isArray(res && res.data) ? res.data : []
        this.plans = list.map(item => {
          const id = item && item.id != null ? item.id : ''
          const title = String((item && item.contentTitle) || '').trim()
          const rawTime = String((item && item.createTime) || '').trim()
          const date = rawTime ? rawTime.slice(0, 10) : ''
          let month = ''
          let day = ''
          if (date) {
            const parts = date.split('-')
            if (parts.length >= 3) {
              month = parts[1]
              day = parts[2]
            }
          }
          const img = this.sanitizeUrl(item && (item.contentImage || item.coverImage || item.imageUrl)) || defaultPlanThumb
          return {
            id,
            title,
            img,
            date,
            month,
            day,
            contentTitle: item.contentTitle,
            createTime: item.createTime,
            viewCount: item.viewCount,
            contentText: item.contentText
          }
        })
      } catch (err) {
        this.plans = []
      }
    },
    initSwiper() {
      if (this.hotSlides.length < 2) return
      this.$nextTick(() => {
        if (this.hotSwiper && this.hotSwiper.destroy) {
          this.hotSwiper.destroy(true, true)
          this.hotSwiper = null
        }
        
        const swiperEl = document.querySelector('.mySwiper')
        if (!swiperEl) return
        
        this.hotSwiper = new Swiper('.mySwiper', {
          modules: this.modules,
          effect: 'coverflow',
          direction: 'horizontal',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          loop: false,
          speed: 0,
          autoplay: false,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 260,
            modifier: 1.2,
            slideShadows: false
          },
          pagination: {
            el: '.mySwiper .swiper-pagination',
            clickable: true
          }
        })
      })
    },
    sanitizeUrl(url) {
      const raw = String(url || '').trim()
      if (!raw) return ''
      return raw.replace(/`/g, '').trim()
    },
    bannerStyle(banner) {
      const adImage = this.sanitizeUrl(banner && banner.adImage)
      if (adImage) {
        return {
          backgroundImage: `url(${adImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      }
      return { background: 'linear-gradient(90deg,#4f46e5,#7c3aed)' }
    },
    openAd(ad) {
      const link = this.sanitizeUrl(ad && ad.adLink)
      if (!link) return
      // Add view count if needed, similar to index logic or just open
      window.open(link, '_blank', 'noopener,noreferrer')
    },
    async fetchBanners() {
      try {
        const res = await getAdvertisementList({
          displayPosition: 'question_bank_list'
        })
        const list = Array.isArray(res && res.data) ? res.data : []
        const enabled = list.filter(item => Number(item && item.enableStatus) === 1 && Number(item && item.adStatus) === 1)

        // Process Carousel Ads
        const carouselAds = enabled.filter(item => String(item && item.adType) === 'carousel')
        this.carouselAds = carouselAds.map(item => ({
            id: item && item.id != null ? item.id : '',
            adTitle: String((item && item.adTitle) || '').trim(),
            adImage: this.sanitizeUrl(item && item.adImage),
            adLink: this.sanitizeUrl(item && item.adLink),
            raw: item
          }))

        // Process Popup Ads
        const popupAds = enabled.filter(item => String(item && item.adType) === 'popup')
        if (popupAds.length > 0) {
          this.popupAd = {
            ...popupAds[0],
            adImage: this.sanitizeUrl(popupAds[0].adImage),
            adLink: this.sanitizeUrl(popupAds[0].adLink)
          }
        }

        // Process Float Ads
        const floatAds = enabled.filter(item => String(item && item.adType) === 'float')
        if (floatAds.length > 0) {
          this.floatAd = {
            ...floatAds[0],
            adImage: this.sanitizeUrl(floatAds[0].adImage),
            adLink: this.sanitizeUrl(floatAds[0].adLink)
          }
        }

        // If no type specified, maybe fallback to carousel? 
        // For now, assuming existing ads might lack adType, we might want to default them to carousel if adType is missing.
        // But the previous code just took everything. 
        // Let's assume strict typing as requested.
        // Or, to be safe: any ad with missing adType or unknown adType goes to carousel?
        // The user said "adType为popup... adType为banner... adType为float...".
        // Implicitly others are carousel.
        const others = enabled.filter(item => !['popup', 'banner', 'float'].includes(String(item && item.adType)))
        if (others.length > 0) {
            const mappedOthers = others.map(item => ({
                id: item && item.id != null ? item.id : '',
                adTitle: String((item && item.adTitle) || '').trim(),
                adImage: this.sanitizeUrl(item && item.adImage),
                adLink: this.sanitizeUrl(item && item.adLink),
                raw: item
            }))
            this.carouselAds = [...this.carouselAds, ...mappedOthers]
        }

      } catch (err) {
        this.carouselAds = []
      }
    },
    async fetchBannerAds() {
      try {
        const res = await getAdvertisementList({
          adType: 'carousel',
          displayPosition: 'exam_plan'
        })
        const list = Array.isArray(res && res.data) ? res.data : []
        const enabled = list.filter(item => Number(item && item.enableStatus) === 1 && Number(item && item.adStatus) === 1)
        this.bannerAds = enabled.map(item => ({
          ...item,
          adImage: this.sanitizeUrl(item && item.adImage),
          adLink: this.sanitizeUrl(item && item.adLink),
          adTitle: String((item && item.adTitle) || '').trim()
        }))
      } catch (err) {
        this.bannerAds = []
      }
    },
    async fetchPlanImages() {
      try {
        const res = await getAdvertisementList({
          adType: 'carousel',
          displayPosition: 'exam_plan_left'
        })
        const list = Array.isArray(res && res.data) ? res.data : []
        const enabled = list.filter(item => Number(item && item.enableStatus) === 1 && Number(item && item.adStatus) === 1)
        if (enabled.length > 0) {
          this.planImages = enabled.map(item => this.sanitizeUrl(item && item.adImage))
        } else {
          this.planImages = [require('@/assets/new_picture/l_pic00.png')]
        }
      } catch (err) {
        this.planImages = [require('@/assets/new_picture/l_pic00.png')]
      }
    },
    async fetchExamList() {
      this.hallLoading = true
      try {
        let status = 1 // default ongoing
        if (this.hallStatusTab === '未开始') status = 0
        else if (this.hallStatusTab === '历史考试') status = 2

        const res = await getFrontendExamList({
          pageNum: this.hallPageNum,
          pageSize: this.hallPageSize,
          status
        })
        const list = (res && res.data && res.data.list) || []
        this.hallTotal = (res && res.data && res.data.total) || 0

        this.halls = list.map(item => {
          let st = 'ongoing'
          if (item.status === 0) st = 'upcoming'
          else if (item.status === 2) st = 'ended'
          
          return {
            id: item.id,
            category: item.courseName || '财税金融',
            title: item.examName,
            start: item.examStartTime,
            end: item.examEndTime,
            duration: item.answerDuration,
            total: item.totalScore,
            pass: item.passScore,
            status: st
          }
        })
      } catch (err) {
        this.halls = []
        this.hallTotal = 0
      } finally {
        this.hallLoading = false
      }
    },
    async fetchHotExams() {
      try {
        const res = await getFrontendExamList({ pageNum: 1, pageSize: 50 })
        const data = res && res.data ? res.data : null
        const list = Array.isArray(data) ? data : (data && Array.isArray(data.list) ? data.list : [])
        const sorted = [...list].sort((a, b) => {
          const aTime = a.examStartTime || a.createTime || ''
          const bTime = b.examStartTime || b.createTime || ''
          return String(bTime).localeCompare(String(aTime))
        })
        let slides = sorted.slice(0, 3).map(item => ({
          id: item.id,
          title: item.examName,
          start: item.examStartTime,
          end: item.examEndTime,
          duration: item.answerDuration,
          total: item.totalScore,
          pass: item.passScore,
          coverImage: item.coverImage
        }))

        // 如果不足3场，复制填补至3场
        if (slides.length > 0 && slides.length < 3) {
          const len = slides.length
          while (slides.length < 3) {
            const randomIndex = Math.floor(Math.random() * len)
            slides.push({ ...slides[randomIndex], id: slides[randomIndex].id + '_' + slides.length })
          }
        }

        this.hotSlides = slides
      } catch (err) {
        console.error('Failed to fetch hot exams:', err)
        this.hotSlides = []
      }
    },
    goHotExam(h) {
      if (h && h.id) {
        this.$router.push(`/exam-detail/${h.id}`)
      }
    },
    startHotCoverflowAutoScroll() {
      this.stopHotCoverflowAutoScroll()
      this.hotCoverflowTimer = setInterval(() => {
        if (this.hotSlides && this.hotSlides.length > 1) {
          this.currentHotIndex = (this.currentHotIndex + 1) % this.hotSlides.length
        }
      }, 5000)
    },
    stopHotCoverflowAutoScroll() {
      if (this.hotCoverflowTimer) {
        clearInterval(this.hotCoverflowTimer)
        this.hotCoverflowTimer = null
      }
    },
    extractListAndTotal(data) {
      if (!data) return { list: [], total: 0 }
      const list = Array.isArray(data.list)
        ? data.list
        : (Array.isArray(data.records) ? data.records : (Array.isArray(data.items) ? data.items : []))
      const total = data.total == null ? list.length : Number(data.total)
      return { list, total: Number.isNaN(total) ? list.length : total }
    },
    normalizeCourse(item, index) {
      const id = (item && (item.id ?? item.courseId ?? item.course_id)) ?? index
      const courseName = (item && (item.courseName ?? item.title ?? item.name)) || ''
      const subtitle = (item && (item.subtitle ?? item.desc ?? item.description)) || ''
      const coverImage = (item && (item.coverImage ?? item.cover ?? item.image)) || ''
      const viewCountRaw = item && (item.viewCount ?? item.studentCount ?? item.students)
      const viewCount = viewCountRaw == null ? 0 : Number(viewCountRaw)

      const discountPrice = item && (item.discountPrice ?? item.discount_price)
      const currentPrice = item && (item.currentPrice ?? item.current_price)
      const salePrice = item && (item.salePrice ?? item.sale_price)
      const priceNumberRaw = discountPrice ?? currentPrice ?? salePrice ?? 0
      const priceNumber = priceNumberRaw == null ? 0 : Number(priceNumberRaw)
      const priceText = priceNumber > 0 ? `¥${priceNumber}` : '免费'

      return {
        id,
        courseName,
        subtitle,
        coverImage,
        viewCount: Number.isNaN(viewCount) ? 0 : viewCount,
        priceText,
        raw: item
      }
    },
    async fetchCourseList() {
      if (this.courseLoading) return
      this.courseLoading = true
      try {
        const params = {
          keyword: this.courseKeyword || undefined,
          pageNum: this.coursePageNum,
          pageSize: this.coursePageSize
        }
        const res = await getCourseList(params)
        const { list, total } = this.extractListAndTotal(res && res.data)
        this.courseList = list.map((item, index) => this.normalizeCourse(item, index))
        this.courseTotal = total
      } catch (err) {
        this.courseList = []
        this.courseTotal = 0
        this.$message.error((err && err.message) || '课程列表加载失败')
      } finally {
        this.courseLoading = false
      }
    },
    handleCoursePageChange(page) {
      this.coursePageNum = page
      this.fetchCourseList()
    },
    goCourse(course) {
      const id = course && course.id
      if (id == null || id === '') return
      // 已购买直接跳学习页
      if (course.isPurchased && this.$store.getters['auth/isLoggedIn']) {
        this.$router.push({ name: 'learn', params: { id } })
        return
      }
      this.$router.push({ name: 'course', params: { id } })
    },
    goToExam(examId) {
      this.$router.push(`/my-courses/exam-detail/${examId}`);
    },
    goPlan(p) {
      if (!p || !p.id) return
      this.$router.push({ name: 'examPlanDetail', params: { id: p.id, planData: p } })
    },
    goToExamList() {
      this.$router.push({ name: 'examList' })
    },
    async doExam(h) {
      const isLoggedIn = this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.isLoggedIn
      if (!isLoggedIn) {
        window.dispatchEvent(new Event('auth:login-required'))
        return
      }
      
      try {
        const res = await getMyExamList({ pageNum: 1, pageSize: 100 })
        const list = (res && res.data && res.data.list) || []
        const hasExam = list.some(item => String(item && item.id) === String(h.id))
        
        if (!hasExam) {
          this.$message({
            message: '您没有报名当前考试',
            type: 'warning',
            center: true
          })
          return
        }
        
        this.$router.push({
          name: 'examIntro',
          params: { id: h.id },
          query: {
            title: h.title,
            duration: h.duration,
            total: h.total,
            pass: h.pass,
            start: h.start,
            end: h.end
          }
        })
      } catch (err) {
        this.$message.error('检查考试报名状态失败')
      }
    },
    async submitQuery() {
      const name = (this.form.name || '').trim()
      const ticketNo = (this.form.ticketNo || '').trim()
      const idNo = (this.form.idNo || '').trim()
      if (!name) {
        this.$message({
          message: '请填写学员姓名',
          type: 'warning',
          center: true,
          offset: window.innerHeight / 2 - 50
        })
        return
      }
      if (!ticketNo && !idNo) {
        this.$message({
          message: '请填写准考证号或证件号码（二选一）',
          type: 'warning',
          center: true,
          offset: window.innerHeight / 2 - 50
        })
        return
      }
      try {
        const res = await getGradeQuery({
          examNumber: ticketNo || undefined,
          idCard: idNo || undefined,
          realName: name
        })
        if (res.code === 200) {
          this.queryResult = res.data
          this.appendHistory(this.queryResult)
          this.queryDialogVisible = true
          this.$message({
            message: '查询成功',
            type: 'success',
            center: true,
            offset: window.innerHeight / 2 - 50
          })
        } else {
          this.$message({
            message: res.message || '查询失败',
            type: 'error',
            center: true,
            offset: window.innerHeight / 2 - 50
          })
        }
      } catch (err) {
        this.$message({
          message: err.message || '查询出错',
          type: 'error',
          center: true,
          offset: window.innerHeight / 2 - 50
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container { min-height: 100vh; display: flex; flex-direction: column; background: #f4f6f8; }
.main-content { flex: 1; margin-top: 0; background: #fff; }

.hero { background: #fff; }
.hero-inner { display:none; }
.hero-text { max-width: 560px; }
.badge { display:inline-block; background:#ffb100; color:#1f1f1f; padding:6px 10px; border-radius:6px; margin-bottom:16px; font-weight:600; }
.h1 { font-size: 40px; font-weight: 700; margin-bottom: 8px; letter-spacing: 2px; }
.h2 { font-size: 18px; opacity: .9; margin-bottom: 24px; }
.actions { display:flex; gap: 12px; }
.carousel-slide { height: 360px; background: linear-gradient(90deg,#4f46e5,#7c3aed); position: relative; }
.overlay { position: absolute; left: 8%; top: 50%; transform: translateY(-50%); color: #fff; }

.sec-head { 
  display: flex; 
  flex-direction: column;
  align-items: center; 
  justify-content: center; 
  gap: 10px;
  margin: 40px 0 30px; 
}
.title { 
  font-size: 28px; 
  font-weight: 700; 
  color: #333; 
  display: flex; 
  align-items: center; 
  gap: 10px; 
}
.title .tag { 
  width: 32px; 
  height: 32px; 
  object-fit: contain; 
  border-radius: 0; 
  display: inline-block; 
}

/* Plan Section */
.plan {
  padding: 40px 0;
  background: #fff;
  margin-bottom: 60px;
}
.subtitle { 
  font-size: 14px; 
  color: #666; 
  letter-spacing: 1px;
  margin-top: 0; 
  font-weight: 400;
  text-align: center;
}

.plan-wrap { 
  display: flex; 
  gap: 32px; 
  background: #fff;
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 12px 48px rgba(0,0,0,0.03);
}

.plan-image { 
  width: 40%; 
  aspect-ratio: 1;
  flex-shrink: 0; 
  border-radius: 12px; 
  overflow: hidden; 
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  position: relative;

  .el-carousel {
    height: 100%;
  }
}
.plan-carousel-img { width: 100%; height: 100%; object-fit: cover; display: block; }

.custom-indicators {
  position: absolute;
  left: 10px;
  bottom: 8px;
  display: flex;
  gap: 4px;
  z-index: 10;
}
.indicator-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255,255,255,0.5);
  cursor: pointer;
  transition: all 0.3s;
}
.indicator-dot.active {
  background: #fff;
  width: 12px;
  border-radius: 3px;
}

.plan-list-container { 
  flex: 1; 
  display: flex; 
  flex-direction: column; 
  justify-content: flex-start; 
  min-width: 0; 
  max-height: 480px; 
  overflow-y: auto; 
}
.plan-list { display: flex; flex-direction: column; gap: 12px; min-width: 0; }

.plan-item { 
  display: flex; 
  align-items: center; 
  gap: 20px; 
  padding: 16px 24px; 
  border-radius: 12px; 
  background: #fff;
  border-bottom: 1px solid #f5f7fa;
  cursor: pointer; 
  transition: all 0.3s ease;
  min-width: 0;
}
.plan-item:last-child { border-bottom: none; }
.plan-item:hover { 
  background: #fcfcfc;
  transform: translateX(4px);
}

.plan-date-box {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606266;
  font-weight: 700;
  font-family: DIN, sans-serif;
  flex-shrink: 0;
  background: #fff;
  flex-direction: column;
  line-height: 1;
  gap: 2px;
}
.plan-date-box.highlight {
  background: linear-gradient(135deg, #6A5AF9 0%, #3E2CCD 100%);
  border: none;
  color: #fff;
  box-shadow: 0 4px 10px rgba(62, 44, 205, 0.2);
}
.d-month { font-size: 14px; }
.d-sep { display: none; }
.d-day { font-size: 16px; }

.plan-info { flex: 1; min-width: 0; overflow: hidden; }
.plan-title { 
  font-size: 16px; 
  color: #303133; 
  font-weight: 500; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
}
.plan-title.highlight { color: #ef4444; font-weight: 600; }

.plan-arrow { color: #e0e0e0; font-size: 16px; }
.plan-item:hover .plan-arrow { color: #6A5AF9; }

.query {
  background: url('~@/assets/new_picture/ks_bg01.png') no-repeat center center;
  background-size: cover;
  padding: 80px 0 100px;
}
.query .sec-head .title {
  color: #333; /* Adjusted for better visibility if needed, or keep white if bg is dark */
}
.query-container {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.05);
  padding: 40px;
  display: flex;
  position: relative;
  min-height: 500px;
}
.form-card-blue {
  width: 480px;
  background: #5E6EF6; /* Blue background */
  border-radius: 12px;
  padding: 30px;
  color: #fff;
  box-shadow: 0 10px 30px rgba(94,110,246,0.3);
  z-index: 2;
  flex-shrink: 0;
}
.card-header {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  letter-spacing: 1px;
}
.form-blue .form-item {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding: 5px 15px;
}
.form-blue .label {
  color: #333;
  font-weight: 600;
  white-space: nowrap;
  min-width: 80px;
}
.form-blue ::v-deep .el-input__inner {
  border: none;
  background: transparent;
  padding: 0;
  height: 40px;
  line-height: 40px;
  color: #333;
}
.query-btn-blue {
  width: 100%;
  background: #3928B1;
  border-color: #3928B1;
  color: #fff;
  height: 48px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 4px;
  margin-top: 10px;
}

.right-panel {
  flex: 1;
  padding-left: 50px;
  position: relative;
}
.notice-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  margin-bottom: 20px;
}
.nt-title {
  font-size: 18px;
  font-weight: 700;
  color: #3928B1;
  border-left: 4px solid #3928B1;
  padding-left: 10px;
}
.dots {
  display: flex;
  gap: 6px;
}
.dot {
  width: 8px;
  height: 8px;
  background: #ddd;
  border-radius: 50%;
}
.dot:first-child { background: #FFB100; }

.violation-list {
  height: 300px;
  overflow-y: auto;
  padding: 10px 0;
}

.violation-list::-webkit-scrollbar {
  width: 6px;
}

.violation-list::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

.violation-list::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}

.v-item {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  padding: 8px 0;
}
.tag-violation {
  background: #FF4B4B;
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 10px;
  white-space: nowrap;
  flex-shrink: 0;
  margin-top: 3px;
}
.v-text {
  color: #333;
}

.no-violation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.side-tips {
  position: absolute;
  right: -150px;
  top: 50px;
  color: #FF4B4B;
  font-size: 14px;
  line-height: 2;
}

.left-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-shrink: 0;
}
.query-desc {
  width: 480px;
  background: #f0f2f5;
  color: #666;
  padding: 15px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.8;
}

.course-search { padding: 12px 0 30px; }

.result-box {
  padding: 10px 20px;
}
.result-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 16px;
}
.result-row .label {
  width: 100px;
  color: #606266;
  text-align: right;
  margin-right: 10px;
}
.result-row .value {
  color: #303133;
  font-weight: 500;
}
.result-row .value.score {
  color: #f56c6c;
  font-size: 20px;
  font-weight: bold;
}
.course-body { min-height: 240px; }
.course-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }
.course-card { 
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  border: 1px solid #f0f0f0;
  min-width: 0;
}
.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.08);
}
.course-thumb { 
  height: 160px;
  width: 100%;
  background: #f5f5f5;
  border-radius: 0;
}
.course-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.course-info { padding: 16px; }
.course-tt { 
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.course-sub { 
  font-size: 12px;
  color: #999;
  margin-bottom: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: auto;
  margin-top: 0;
  display: block;
}
.course-meta { display: flex; align-items: center; justify-content: space-between; margin-top: 0; }
.course-views { font-size: 12px; color: #999; }
.course-price { font-size: 18px; font-weight: 700; color: #FF4D4F; }
.course-pager { display: flex; justify-content: center; margin: 24px 0 10px; }

.countdown .cd-wrap { display:flex; justify-content:center; padding: 20px 0; }
.cd-card { width: 520px; background:#fff; border-radius:16px; box-shadow: 0 16px 40px rgba(0,0,0,.08); text-align:center; padding: 24px; }
.cd-title { font-weight: 700; margin-bottom: 16px; }
.cd-time { display:flex; align-items:center; justify-content:center; gap: 10px; margin-bottom: 16px; }
.num { font-size: 32px; font-weight: 800; color:#4f46e5; }
.unit { color:#606266; }

.hot { 
  padding: 60px 0 80px;
  background: url('~@/assets/new_picture/ks_bg02.png') no-repeat center center;
  background-size: cover;
}
.hot-rotator {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
}

.hot-featured {
  .hot-coverflow {
    position: relative;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    overflow: hidden;
    perspective: 1000px;

    .coverflow-item {
      position: absolute;
      width: 65%;
      height: 190px;
      transition: all 0.5s ease;
      opacity: 0;
      z-index: 1;
      border-radius: 6px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      &.active {
        opacity: 1;
        transform: translateX(0) scale(1) rotateY(0deg);
        z-index: 3;
        box-shadow: 0 8px 24px rgba(0,0,0,0.2);
      }

      &.prev {
        opacity: 0.9;
        transform: translateX(-40%) scale(0.85) rotateY(35deg);
        z-index: 2;
      }

      &.next {
        opacity: 0.9;
        transform: translateX(40%) scale(0.85) rotateY(-35deg);
        z-index: 2;
      }
    }
  }

  .hot-info {
    text-align: center;

    .hot-title {
      font-size: 20px;
      font-weight: 600;
      color: #fff;
      margin-bottom: 10px;
      line-height: 1.4;
    }

    .hot-time,
    .hot-meta {
      font-size: 14px;
      color: #fff;
      margin-bottom: 6px;
    }

    .hot-card-btn {
      margin-top: 16px;
      min-width: 180px;
      border-radius: 999px;
    }
  }
}
.halls {
  padding: 40px 0 0;
  margin-bottom: 60px;
}
.hall-tabs-centered {
  display: inline-flex;
  justify-content: center;
  margin-bottom: 30px;
  background: #fff;
  padding: 4px;
  border-radius: 4px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.ht-item {
  padding: 8px 32px;
  border-radius: 4px;
  background: transparent;
  color: #666;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  border: none;
  font-weight: 500;
}
.ht-item.active {
  background: #3E2CCD;
  color: #fff;
  border-color: #3E2CCD;
  box-shadow: none;
}
.hlist.grid-mode-multi {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.hlist.grid-mode-single {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.view-more-btn {
  text-align: center;
  margin-top: 20px;
  color: #3E2CCD;
  font-size: 14px;
  cursor: pointer;
  padding: 10px 0;
}

.view-more-btn:hover {
  color: #5342e0;
}
.exam-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: all 0.3s;
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.exam-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
}
.ec-head {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  min-width: 0;
}
.ec-tag {
  background: #3E2CCD;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  margin-right: 12px;
  white-space: nowrap;
}
.ec-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ec-body {
  flex: 1;
  font-size: 13px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 16px;
}
.ec-row {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.ec-row .sep {
  display: inline-block;
  width: 1px;
  height: 12px;
  background: #eee;
  margin: 0 12px;
}
.ec-foot {
  text-align: right;
  border-top: 1px solid #f9f9f9;
  padding-top: 16px;
}
.enter-btn {
  border-color: #3E2CCD;
  color: #3E2CCD;
  padding: 8px 24px;
}
.enter-btn:hover, .enter-btn:focus {
  background: #3E2CCD;
  color: #fff;
  border-color: #3E2CCD;
}

@media (max-width: 768px) {
  .hlist.grid-mode-multi, .hlist.grid-mode-single { grid-template-columns: 1fr; }
}

.table { margin-top: 10px; }

@media (max-width: 992px) {
  .plan .plan-wrap { flex-direction: column; }
  .plan .right, .form-side { width: 100%; }
}

@media (max-width: 992px) {
  .course-grid { grid-template-columns: repeat(2, 1fr); }
}

.flat-list {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 50px 0;
  flex-wrap: wrap;
}

.flat-item {
  width: 320px;
  height: 320px;
}
  /* Banner Section */
  .banner-section {
    margin-top: 20px;
  }

  .banner-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .banner-item {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    height: 120px;
  }

  .banner-item img {
    width: 100%;
    display: block;
    object-fit: cover;
  }

  /* Popup Ad */
  ::v-deep .ad-popup-dialog {
    background: transparent;
    box-shadow: none;
  }
  ::v-deep .ad-popup-dialog .el-dialog__header {
    display: none;
  }
  ::v-deep .ad-popup-dialog .el-dialog__body {
    padding: 0;
    background: transparent;
  }

  .ad-popup-content {
    position: relative;
    text-align: center;
  }

  .ad-popup-content .ad-image {
    cursor: pointer;
    border-radius: 12px;
    overflow: hidden;
  }

  .ad-popup-content .ad-image img {
    max-width: 100%;
    display: block;
  }

  .ad-popup-content .ad-close {
    margin-top: 16px;
    font-size: 36px;
    color: #fff;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s;
  }

  .ad-popup-content .ad-close:hover {
    opacity: 1;
  }

  /* Float Ad */
  .float-ad {
    position: fixed;
    right: 20px;
    bottom: 100px;
    z-index: 2000;
    width: 200px; /* Adjust as needed */
  }

  .float-ad-content {
    position: relative;
  }

  .float-ad-content .ad-image {
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }

  .float-ad-content .ad-image img {
    width: 100%;
    display: block;
  }

  .float-ad-content .ad-close {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 24px;
    height: 24px;
    background: rgba(0,0,0,0.5);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
  }
</style>
